import { render, staticRenderFns } from "./RightCourse.vue?vue&type=template&id=55fb1ee0&scoped=true&"
import script from "./RightCourse.vue?vue&type=script&lang=js&"
export * from "./RightCourse.vue?vue&type=script&lang=js&"
import style0 from "./RightCourse.vue?vue&type=style&index=0&id=55fb1ee0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fb1ee0",
  null
  
)

export default component.exports